import React from "react";
import Card from "../../components/Card";
import SettingsCard from "./Components/SettingsCard/SettingsCard";
import SectionHeader from "./Components/SectionHeader/SectionHeader";
import { useNavigate } from "react-router";
import cn from "classnames";
import styles from "./SettingsDashboard.module.sass"

const SettingsDashboard = () => {
  const sections = {
    general: {
      items: [
        {
          icon: "accessControl",
          title: "Access Control",
          description:
            "Control user visibility & access to features & actions based on user roles & manage roles",
          fill: "#FF6A55",
          path: "/settingsDashboard/accessControl",
        },
      ],
      colorClass: "title-red"
    },
    features: {
      items: [
        {
          icon: "turnFeatures",
          title: "Turn Features On/Off",
          description: "Control which features are enabled for your store",
          fill: "#2A85FF",
        },
        {
          icon: "tag",
          title: "Tags",
          description:
            "Control which actions trigger addition of tags & create new tags",
          fill: "#2A85FF",
          path:"/settingsDashboard/tags"
        },
        {
          icon: "camera",
          title: "Action Barcodes",
          description: "Setup barcodes for different purposes",
          fill: "#2A85FF",
          path:"/settingsDashboard/camera&Barcode",
        },
        {
          icon: "settingCamera",
          title: "Cameras",
          description: "Setup cameras and link them to barcodes",
          fill: "#2A85FF",
          path:"/settingsDashboard/Cameras"
        },
        {
          icon: "store",
          title: "Store Settings",
          description:
            "Customize your store image and understand your needs to suit your store's needs",
          fill: "#2A85FF",
          path:"/settingsDashboard/storeSettings",
        },
      ],
      colorClass: "title-blue"
    },
    billing: {
      items: [
        {
          icon: "information",
          title: "Information",
          description: "View current plan and billing information",
          fill: "#8E59FF",
        },
        {
          icon: "changePlan",
          title: "Change Plan",
          description: "Upgrade to a better plan",
          fill: "#8E59FF",
        },
        {
          icon: "billingHistory",
          title: "Billing History",
          description: "Compare plans, change",
          fill: "#8E59FF",
        },
      ],
      colorClass: "title-purple"
    },
  };

  const navigate = useNavigate();

  return (
    <Card>
      {Object.entries(sections).map(([sectionName, section]) => (
        <div key={sectionName}>
          <SectionHeader
            title={sectionName.charAt(0).toUpperCase() + sectionName.slice(1)}
            colorClass={section.colorClass}
          />
          <div
            className={cn("grid grid-cols-2 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 gap-10",styles.settingscard)}
            style={{ width: "65%", marginBottom: "10px" }}
          >
            {section.items.map((item) => (
              <SettingsCard
                key={item.title}
                icon={item.icon}
                title={item.title}
                description={item.description}
                className={item.className}
                onClick={() => navigate(item.path)}
                fill={item.fill}
              />
            ))}
          </div>
        </div>
      ))}
    </Card>
  );
};

export default SettingsDashboard;